import React from 'react'
import { NullableDate, NullableDateRange } from '../utility'
import { makeHtmlSafeId } from './Control'
import { LanguageContext } from '../contexts'
import DatePicker from 'react-datepicker'
import { DateFormats } from '../format'

import "react-datepicker/dist/react-datepicker.css";

export interface DateSelectorProps {
	value: NullableDate
	minMax: NullableDateRange
	onChange: (range: NullableDate) => void
	placeHolder?: string
	label?: string
}

export function DateSelector(props: DateSelectorProps) {
	const { locale } = React.useContext(LanguageContext)

	const controlId = makeHtmlSafeId(props.label || 'date-control')
	const labelControl = props.label ? <label htmlFor={controlId} className='label'>{props.label}</label> : null

	return (
		<div className='date-picker field'>
			{labelControl}
			<div className='control'>
				<DatePicker
					id={controlId}
					selected={props.value}
					onChange={props.onChange}
					placeholderText={props.placeHolder}
					minDate={props.minMax[0]}
					maxDate={props.minMax[1]}
					className='input'
					showPopperArrow={false}
					isClearable={true}
					locale={locale}
					dateFormat={DateFormats.DateFns.Date}
				/>
			</div>
		</div>
	)
}

export default DateSelector
